import React, {ContextType} from 'react';
import {
  withSystem,
  Plugins,
  Atom,
  type AtomRenderProps,
} from '@packages/systems/wfdl';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {
  EvaluatedNodeData,
  getChildren,
  getInPojo,
  getTagOrElse,
} from '@packages/utilities/data-utils';
import {List} from 'immutable';
import {MENU_STATE_SHOW} from '@packages/utilities/expression-path-constants';

// @ts-expect-error - TS2314 - Generic type 'ContextType' requires 1 type argument(s).
const maybeAddOpen = (context: ContextType) => (classes: List<string>) => {
  return context.get('menu') === MENU_STATE_SHOW
    ? classes.push('w--open')
    : classes;
};

const DropdownToggle = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    context,
    renderChild,
  }: AtomRenderProps) => {
    const Tag = getTagOrElse(getInPojo(data, ['tag']), 'div');
    const dropdownToggleClasses = classes
      .push('w-dropdown-toggle')
      .update(maybeAddOpen(context));
    return (
      <Tag {...generateAttributes(attributes, dropdownToggleClasses)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Dropdown Toggle',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  showEmpty: false,
  constraints: {
    pinToParent: true,
  },
  render: DropdownToggle,
  fields: {
    tag: withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'div',
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    ),
    children: TListOfElement,
  },
  autoEngagementTrackingAttribute: true,
});

export default config;
